import './Styles/dist/Styles.css';
import Page01 from './Components/Page01.js'
import TonsPage from './Components/TonsPage.js'
import MoneyPage from './Components/MoneyPage';
import WattsPage from './Components/WattsPage';
import AlmostThere from './Components/AlmostThere';
import Success from './Components/Success';
import { useState } from 'react';
import exitIcon from './Media/Clearloop_XIcon_01.svg'


function App() {
  const [activePage, setActivePage] = useState('home');

  const [userInputType, setUserInputType] = useState('')
  const [userInputValue, setUserInputValue] = useState(0)

  let tons = 0;
  let dollars = 0;
  let watts = 0;




  const processUserSelection = () => {
    
    switch(userInputType){
      case 'tons':
        tons = Math.floor(userInputValue);
        dollars = parseFloat(tons * 14.80).toFixed(2);
        watts = tons * 37;
        break
      case 'dollars':
        dollars = parseFloat(userInputValue).toFixed(2);
        tons = Math.floor(dollars / 14.80);
        watts = tons * 37;
        break
      case 'watts':
        watts = parseFloat(userInputValue);
        tons = Math.floor(watts / 37);
        dollars = parseFloat((watts / 37) * 14.80).toFixed(2);
        break
      default:
        console.error('there was an issue converting')
        break
    }
  }

  const pageFlow = () => {
    switch(activePage){
      case 'home':
        return(
          <Page01 setPage={setActivePage}
            userInputType={setUserInputType} />
        )
      case 'tons':
        return(
          <TonsPage 
            setPage={setActivePage} 
            userInputValue={setUserInputValue} />
        )
      case 'dollars':
        return(
          <MoneyPage 
            setPage={setActivePage} 
            userInputValue={setUserInputValue} />
        )
      case 'watts':
        return(
          <WattsPage 
            setPage={setActivePage} 
            userInputValue={setUserInputValue} />
        )
        
      case 'almostThere':
        return(
          <AlmostThere setPage={setActivePage} userType={userInputType} userValue={userInputValue} />
        )
      case 'success':
        processUserSelection()
        return(
          <Success tons={tons} money={dollars} watts={watts} choice={userInputType} setPage={setActivePage}/>
        )
      default:
        return(
          <Page01 setPage={setActivePage}
          userInputType={setUserInputType} />
        )
    }
  }


  return (
    <div className="App">
        
        <div className='popup-container'>
          <img id="exit" className='pointer' alt="exit icon" src={exitIcon} onClick={() => window.location.assign('https://clearloop.us/ms-panola/')} />
          {pageFlow()}
        </div>


    </div>
  );
}

export default App;
